import { render, staticRenderFns } from "./BaseInputVuelidate.vue?vue&type=template&id=74023bfd&scoped=true&"
import script from "./BaseInputVuelidate.vue?vue&type=script&lang=ts&"
export * from "./BaseInputVuelidate.vue?vue&type=script&lang=ts&"
import style0 from "./BaseInputVuelidate.vue?vue&type=style&index=0&id=74023bfd&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74023bfd",
  null
  
)

export default component.exports